var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6519_26358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.45 1.65L2.475 2.95C2.28188 3.20749 2.18533 3.33623 2.18757 3.44399C2.18952 3.53777 2.23349 3.62572 2.30734 3.68355C2.39221 3.75 2.55314 3.75 2.875 3.75H12.125C12.4469 3.75 12.6078 3.75 12.6927 3.68355C12.7665 3.62572 12.8105 3.53777 12.8124 3.44399C12.8147 3.33623 12.7181 3.20749 12.525 2.95L11.55 1.65M3.45 1.65C3.56 1.50333 3.615 1.43 3.6847 1.37711C3.74644 1.33026 3.81635 1.29531 3.89087 1.27403C3.975 1.25 4.06667 1.25 4.25 1.25H10.75C10.9333 1.25 11.025 1.25 11.1091 1.27403C11.1837 1.29531 11.2536 1.33026 11.3153 1.37711C11.385 1.43 11.44 1.50333 11.55 1.65M3.45 1.65L2.275 3.21667C2.12659 3.41455 2.05238 3.51349 1.99969 3.62245C1.95293 3.71914 1.91883 3.82145 1.89822 3.92685C1.875 4.04563 1.875 4.16931 1.875 4.41667L1.875 11.75C1.875 12.4501 1.875 12.8001 2.01124 13.0675C2.13108 13.3027 2.32231 13.4939 2.55751 13.6138C2.8249 13.75 3.17493 13.75 3.875 13.75L11.125 13.75C11.8251 13.75 12.1751 13.75 12.4425 13.6138C12.6777 13.4939 12.8689 13.3027 12.9888 13.0675C13.125 12.8001 13.125 12.4501 13.125 11.75V4.41667C13.125 4.16931 13.125 4.04563 13.1018 3.92685C13.0812 3.82145 13.0471 3.71914 13.0003 3.62245C12.9476 3.51349 12.8734 3.41455 12.725 3.21667L11.55 1.65M10 6.25C10 6.91304 9.73661 7.54892 9.26777 8.01777C8.79893 8.48661 8.16304 8.75 7.5 8.75C6.83696 8.75 6.20107 8.48661 5.73223 8.01777C5.26339 7.54892 5 6.91304 5 6.25",
    stroke: "#808795",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6519_26358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.35421a978977806720248922cc5450b3.svg";
export { ForwardRef as ReactComponent };